import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { TemplatesCreateAddonsControllerModule } from './controllers/TemplatesCreateAddonsController';

export const TemplatesCreateExceptionAddonsView = angular
  .module('acme.view.application.templates.create.addons', [
    uiRouter,
    'ui.bootstrap',
    TemplatesCreateAddonsControllerModule,
  ])
  .config(function config($stateProvider: StateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default

    $stateProvider.state({
      name: 'application.templates.create.addons',
      url: '/addons',
      views: {
        'subview-main': {
          controller: 'TemplatesCreateAddonsController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/templates/create/addons/addons.tpl.html',
        },
      },
      data: {
        pageTitle: 'Create Event Template',
      },
    });

    $stateProvider.state({
      name: 'application.templates.edit.addons',
      url: '/addons',
      views: {
        'subview-main': {
          controller: 'TemplatesCreateAddonsController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/templates/create/addons/addons.tpl.html',
        },
      },
      data: {
        pageTitle: 'Edit Event Template',
      },
    });
  }).name;
